// src/components/AppHeader.js
import { Layout, Breadcrumb, Space, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import logo from '../../assets/images/simple-logo.png';

const { Header } = Layout;

const AppHeader = ({ onLogout }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userEmail = user?.email || '';

  return (
    <Header style={{
      background: 'inherit',
      padding: '0 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <img src={logo} alt="Logo" style={{ width: '100px', height: 'auto' }} />
      </Breadcrumb>
      
      <Space>
        <span>{userEmail}</span>
        <Button
          type="primary"
          danger
          onClick={onLogout}
          icon={<LogoutOutlined />}
        >
          Logout
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader;